import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Table, Modal, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
// import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
// import '../../../mcss/common.css';
import RequestHeader from '../RequestHeader';
import $ from 'jquery';
import Ad1RequestHeader from './Ad1RequestHeader';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import AD1TransactionComment from './AD1TransactionComment';


function Ad1FinalDocDownload(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [reqSrNo, setReqSrNo] = useState(0);
    const [reqQuantity, setReqQuantity] = useState(0);
    const [reqCoverBank, setReqCoverBank] = useState("0");
    const [ddCoverBank, setDdCoverBank] = useState([]);
    const [reqCoverBankName, setReqCoverBankName] = useState("");
    const [reqCoverValue, setReqCoverValue] = useState("");
    const [coverListData, setCoverListData] = useState([]);
    const [reqCoverTotValue, setReqCoverTotValue] = useState(0);
    // const [reqData, setReqData] = useState([]);
    const [showReject, setShowReject] = useState(false);
    const [rightAprovQty, setRightAprovQty] = useState([]);
    const [showConfirmBox, setShowConfirmBox] = useState(false);
    const [remark, setRemark] = useState("");
    const [viewObj, setViewObj] = useState("");
    const [reqDocVerify, setReqDocVerify] = useState([]);
    const [reqPurpose, setReqPurpose] = useState("0");
    const [reqDocId, setReqDocId] = useState("0");
    const [ddReqDocOptions, setDdReqDocOptions] = useState([]);
    const [reqDocRemark, setReqDocRemark] = useState("");
    const [docListData, setDocListData] = useState([]);
    const [reqDocumentsFinal, setReqDocumentsFinal] = useState(0);
    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'AD1FINALDOCDOWNLOAD'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiAd1, [sid, 'view', JSON.stringify({ srno: props.srno })], function (result) {
                        let resp = JSON.parse(result);
                        console.log(resp);
                        setViewObj(resp[0]);
                        setReqCoverBank(resp[0].trad_bank_code);
                        setReqCoverValue(resp[0].trad_quantity);
                        setReqSrNo(resp[0].trad_srno);
                        setReqQuantity(resp[0].trad_quantity);
                        setReqPurpose(resp[0]?.trad_purpose);
                        // setReqCoverFinal(resp[0].trad_issuercover);
                        // setReqCoverTotValue(resp[0].trad_quantity);
                        setReqCoverBankName(resp[0].issuer_name);
                        // Common.callApi(Common.apiad1coverrate, [sid, 'list', props.srno], function (result) {
                        //     var arr = JSON.parse(result)
                        //     setCoverListData(arr);
                        //     //add all cbalue to total
                        //     setReqCoverTotValue(arr.reduce((a, b) => a + (b.cvalue * 1), 0));
                        //     setReqCoverTotValue(arr[0].cvalue);
                        // });
                        // Common.callApi(Common.apiAddDetails, [sid, 'kycdoclist', resp[0]?.trad_purpose], function (result4) {
                        //     let resp4 = JSON.parse(result4);
                        //     setDdReqDocOptions(resp4);
                        // });
                    });
                    getDocuments();
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function getDocuments() {
        Common.callApi(Common.apiAd1, [sid, 'getDoc', JSON.stringify({ srno: props.srno, pageright: 'AD1FINALDOCUPLOAD' })], function (result) {
            let parsed = JSON.parse(result || "[]");
            setDocListData(parsed || []);
        });
    }

    function btnBackClick() {
        props.callAd1();
    }



    function btnDocumentView(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>Ad1 Final Doc Download</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col> */}
                    <Ad1RequestHeader back={btnBackClick} viewData={viewObj}></Ad1RequestHeader>
                    {/* </Col>
                    </Row> */}

                    <Row>
                        <Col>
                            <h5>Documents</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>

                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.doc_uploadedat}>
                                            <td className='divHide'>{res.doc_srno}</td>
                                            <td>{res.doc_id + ' : ' + res.doc_type}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_filename}</td>
                                            <td>{res.doc_active == 1 ? "ACTIVE" : "INACTIVE"}</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                    <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </span>&nbsp;
                                                    {userRight.query == 1 &&
                                                        <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />
                                                        </span>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>

                </Container>
            </div>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )
}
export default Ad1FinalDocDownload;